import script from "./loadingSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./loadingSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./loadingSpinner.vue?vue&type=style&index=0&id=67a54b0b&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a54b0b"]])

export default __exports__